<app-receipt
  [display_columns]="displayedColumns"
  [staged_receipts]="staged_receipts"
  [sse_name]="'CardReceipt'"
  [upload_field_text]="'receipt.uploadCardReceipt'"
  [validation_schema]="validation_s"
  [upload_handler]="client_proc"
  [lookupPermanent]="lookup_permanent_c"
  [wasm_split_pattern]="_wasm_split_pattern"
  [callme]="callme_c"
  [available_filters]="available_f"
  [get_paginated_data]="get_paginated_data_c"
>
</app-receipt>
